/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetProjectSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type GetProjectRequest = {
  /**
   * The slug of the project to get
   */
  slug: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetProjectSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetProjectSecurity$outboundSchema: z.ZodMiniType<
  GetProjectSecurity$Outbound,
  GetProjectSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getProjectSecurityToJSON(
  getProjectSecurity: GetProjectSecurity,
): string {
  return JSON.stringify(
    GetProjectSecurity$outboundSchema.parse(getProjectSecurity),
  );
}

/** @internal */
export type GetProjectRequest$Outbound = {
  slug: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetProjectRequest$outboundSchema: z.ZodMiniType<
  GetProjectRequest$Outbound,
  GetProjectRequest
> = z.pipe(
  z.object({
    slug: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function getProjectRequestToJSON(
  getProjectRequest: GetProjectRequest,
): string {
  return JSON.stringify(
    GetProjectRequest$outboundSchema.parse(getProjectRequest),
  );
}
